import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Missão",
    text: "Ser a ponte que conecta sonhos ao endereço certo, facilitando o acesso a soluções imobiliárias inovadoras e personalizadas que impulsionam conquistas pessoais e empresariais.",
  },
  {
    n: "02",
    title: "Visão",
    text: "Tornar-se referência no mercado imobiliário por democratizar o acesso a imóveis urbanos e rurais, garantindo uma experiência sem precedentes em facilidade, confiabilidade e suporte humano.",
  },
  {
    n: "03",
    title: "Valores",
    text: "Integridade em cada negociação. Empatia com cada realidade. Inovação em cada solução. Confiança em cada relação construída.",
    tags: ["Integridade", "Empatia", "Inovação", "Confiança"],
  },
];

export const Manifesto = () => (
  <section id="sobre" className="py-24 md:py-36" data-testid="manifesto-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-16 max-w-2xl"
      >
        <p className="mb-4 text-sm font-bold uppercase tracking-[0.25em] text-seed-salad">Sobre a Seed</p>
        <h2 className="font-heading text-4xl font-black tracking-tighter text-seed-deep sm:text-5xl" data-testid="manifesto-title">
          Cada imóvel é uma semente de um novo começo.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-px overflow-hidden bg-seed-deep/10 md:grid-cols-3">
        {chapters.map((c, i) => (
          <motion.article
            key={c.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="group bg-seed-off p-10 transition-colors duration-500 hover:bg-white md:p-12"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <span className="font-heading text-5xl font-light text-seed-salad/60 transition-colors duration-500 group-hover:text-seed-vivid">
              {c.n}
            </span>
            <h3 className="mt-6 font-heading text-2xl font-bold tracking-tight text-seed-deep">{c.title}</h3>
            <p className="mt-4 text-sm leading-relaxed text-seed-deep/70 md:text-base">{c.text}</p>
            {c.tags && (
              <div className="mt-6 flex flex-wrap gap-2">
                {c.tags.map((t) => (
                  <span
                    key={t}
                    className="rounded-full border border-seed-salad/40 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-seed-salad"
                  >
                    {t}
                  </span>
                ))}
              </div>
            )}
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
